import { forwardRef, type Ref } from "react";
import { Button, type ButtonProps } from "./Button.tsx";

type ErrorButtonProps = Omit<ButtonProps, "variant"> & {
  variant?: "error";
};

export const ErrorButton = forwardRef(
  (
    { variant = "error", size = "md", ...rest }: ErrorButtonProps,
    ref: Ref<HTMLButtonElement>,
  ) => <Button ref={ref} variant={variant} size={size} {...rest} />,
);
